import { useTheme } from 'styled-components';
import {
  TitleText,
  DescriptionText,
  RootContainer,
  VideoWrapper,
} from './styles';
import VideoPlayer from '@composites/VideoPlayer';
import { useSelector } from 'react-redux';
import { getEventDetails } from '@store/slices/eventSlice';
import Divider from '@components/Divider';
import { useMobileWidth } from '@utils/hooks';
import { CenterItem } from '@components/LinearLayout';
import Button from '@components/Button';

interface VideoPlayerProps {
  videoItems: Array<{ id: string; link: string; title: string }>;
  title: string;
  description: string;
  buttonText: string;
  buttonURL: string;
}

const VideoSection = ({
  videoItems,
  title,
  description,
  buttonText,
  buttonURL,
}: VideoPlayerProps) => {
  const isMobile = useMobileWidth();
  const sluggedEvent = useSelector(getEventDetails)?.[0];
  const theme = useTheme();

  return (
    <RootContainer>
      <TitleText color={sluggedEvent?.design?.headerFontColor}>
        {title}
      </TitleText>

      <Divider
        height="0.3rem"
        width={isMobile ? '16rem' : '24rem'}
        backgroundColor={sluggedEvent?.design?.themeColor}
      />

      {description && (
        <DescriptionText color={sluggedEvent?.design?.headerFontColor}>
          {description}
        </DescriptionText>
      )}

      <VideoWrapper>
        <VideoPlayer
          isLoading={false}
          videoItems={videoItems}
          selectedVideo={videoItems[0].id}
          textColor={sluggedEvent?.design?.headerFontColor}
        />
      </VideoWrapper>

      {!isMobile && (
        <CenterItem>
          <Button
            title={buttonText}
            backgroundColor={sluggedEvent?.design?.themeColor || ''}
            hoverBackgroundColor={theme.color.mobilityGrey}
            textColor={theme.color.white}
            borderRadius={theme.borderRadius.radius10}
            padding="1.2rem 5.5rem"
            width="max-content"
            onClick={() => {
              if (buttonURL?.startsWith('mailto:')) {
                window.location.href = buttonURL; 
              } else {
                window.open(buttonURL, '_blank', 'noopener,noreferrer');
              }
            }}
          />
        </CenterItem>
      )}
    </RootContainer>
  );
};

export default VideoSection;
